import { useEffect, useState } from 'react';
import { PetNomaRepository } from '../infraestructure/repositories/pet/PetNomaRepository';
import { FindPetByPolicyNumber } from './FindPetByPolicyNumber/FindPetByPolicyNumber';
import { Pet } from 'src/domain/entities';

const petNomaRepository = new PetNomaRepository();

const findPetByPolicyNumber = new FindPetByPolicyNumber(petNomaRepository);

export const usePet = (policyIdentifier: string | undefined = undefined) => {
    const [pet, setPet] = useState<Pet | undefined>(undefined);
    const findPetInformationByPolicyIdentifier = async (policyIdentifier: string) => {
        return await findPetByPolicyNumber.execute(policyIdentifier);
    };

    useEffect(() => {
        if (policyIdentifier) {
            findPetInformationByPolicyIdentifier(policyIdentifier).then(setPet);
        }
    }, [policyIdentifier]);

    return {
        pet,
        findPetByPolicyIdentifier: findPetInformationByPolicyIdentifier,
    };
};
